import * as React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Fade from '@mui/material/Fade';
import { useTheme } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useAuth } from '../../../auth';
import { useNavigate } from 'react-router-dom';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import StarBorderOutlinedIcon from '@mui/icons-material/StarBorderOutlined';
import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import { AppPermissions } from 'routing/AppPermissions';
import CustomSquareButton from 'app/components/buttons/CustomSquareButton';

type RoutePath = {
  title: string;
  path: string;
  icon: React.ReactNode;
  permission?: boolean;
  order: number;
};

function RoutListMenu({}: {}) {
  const theme = useTheme();
  const navigate = useNavigate();
  const { currentUser } = useAuth();

  const routesPath: RoutePath[] = [
    {
      title: 'Dashboard',
      path: '/projects-category',
      icon: <DashboardOutlinedIcon color='primary' className='w-[24px]' />,
      order: 1,
    },
    {
      title: 'Companies',
      path: '/companies/list',
      icon: <StarBorderOutlinedIcon color='primary' className='w-[24px]' />,
      permission: currentUser?.type === AppPermissions.types.tazmeenEmployee,
      order: 2,
    },
    {
      title: 'Projects',
      path: '/projects-category',
      icon: <AssignmentTurnedInOutlinedIcon color='primary' className='w-[24px]' />,
      permission:
        currentUser?.type === AppPermissions.types.clientEmployee &&
        currentUser?.role === AppPermissions.roles.ClientAdmin,
      order: 3,
    },
    // {
    //   title: "User",
    //   path: "notfound",
    //   icon: <PersonOutlineOutlinedIcon color="primary" className="w-[24px]" />,
    //   permission: currentUser?.type === AppPermissions.types.clientEmployee && currentUser?.role === AppPermissions.roles.ClientAdmin,
    //   order: 4,
    // },
    {
      title: 'Control Panel',
      path: '/control-panel',
      icon: <AdminPanelSettingsOutlinedIcon color='primary' className='w-[24px]' />,
      permission: currentUser?.type === AppPermissions.types.tazmeenEmployee,
      order: 5,
    },
    // {
    //   title: "Setting",
    //   path: "notfound",
    //   icon: <SettingsOutlinedIcon color="primary" className="w-[24px]" />,
    //   order: 6,

    // },
  ];

  // Filter and sort routes based on permission and order
  const filteredRoutes = routesPath
    .filter((route) => route.permission !== false)
    .sort((a, b) => a.order - b.order);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <CustomSquareButton
        id='fade-button'
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        onMouseLeave={() => {}}
        title='Show Pages'
        squareSize={40}
        placement='bottom'
      >
        <MenuIcon color='primary' fontSize='medium' />
      </CustomSquareButton>
      <Menu
        id='fade-menu'
        MenuListProps={{
          'aria-labelledby': 'fade-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
        sx={{
          '& .MuiPaper-root': {
            minWidth: '235px',
            maxWidth: '235px',
            transform: `translateY(10px)`, // Adjusts the vertical position
            marginLeft: '-10px',
          },
          '& .MuiList-root': {
            padding: '5px',
          },
        }}
        className=' rounded-md'
      >
        {filteredRoutes.map((item) => (
          <MenuItem
            key={item.order}
            onClick={() => {
              handleClose();
              navigate(item.path);
            }}
            className=' rounded-md'
            sx={{
              '&:hover': {
                color: theme.palette.primary.main,
                backgroundColor: theme.palette.primary.light,
              },
              height: '50px',
              borderRadius: '4px',
            }}
          >
            <div className='flex gap-3 items-center justify-center cursor-pointer rounded-md'>
              {item.icon}
              <span>{item.title}</span>
            </div>
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}

export default RoutListMenu;
